import swal from 'sweetalert'

class DeviceContentController {
  constructor ($translate) {
    'ngInject'

    this.$translate = $translate
  }

  get size () {
    const { content } = this
    let size
    if (!content.isLocked && content.size) {
      size = '(' + Math.round(content.size * 10 / 1048576) / 10 + 'Mo)'
    }
    return size
  }

  displayAlert (checked) {
    const { content, vehicle } = this
    if (vehicle.huType === 'MM12' && content.isFactory && !checked) {
      let alertMessage = this.$translate.instant('my-updates.device.alert_uninstall_factory')
      console.log('Message to display on swal: ' + alertMessage)
      swal({
        text: alertMessage,
        icon: 'warning',
        dangerMode: true,
        closeOnClickOutside: false,
        content: true
      })
    }
    this.checked = !checked
  }
}

export default DeviceContentController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/device-content/device-content.controller.js